module.exports = __webpack_public_path__ + "static/media/github.f1797f34.svg";